import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"


export const useProducts = (page, limit, name) => {
    return useQuery({
        queryKey: ['products', page],
        queryFn: async () => {
            const res = await Axios.get('/product/all', { params: { page, limit, name } });
            return res?.data
        }
    })
}